import React from 'react'
import styled from 'styled-components'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import RoundedBox from '../RoundedBox'
import tokens from './assets/tokens.png'
import tokens2x from './assets/tokens@2x.png'
import Topic from '~shared/Topic'

const IconContainer = styled.div`
    position: relative;
    width: 118px;
    height: 118px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    @media (min-width: ${TABLET}px) {
        width: 134px;
        height: 134px;
    }

    @media (min-width: ${DESKTOP}px) {
        width: 186px;
        height: 186px;
    }
`

const Slide1 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Mine DATA tokens
            </Topic.Title>
            <Topic.Paragraph>
                You can mine DATA by running a Broker node and setting it up for mining.
                By doing so, you help secure and scale the Network,
                and contribute your bandwidth and computing resources to the Network in exchange for DATA tokens.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide2 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Mine DATA tokens
            </Topic.Title>
            <Topic.Paragraph>
                While the full token economics will only go live in the Tatum
                milestone in 2022, Brokers can mine a set amount of token
                rewards in the Brubeck milestone too.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide3 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Mine DATA tokens
            </Topic.Title>
            <Topic.Paragraph>
                The Broker node runs well on commodity hardware, including ordinary computers,
                mini-computers such as Raspberry Pi, and Avado blockchain computers—almost anything that can run Docker or node.js.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide4 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Mine DATA tokens
            </Topic.Title>
            <Topic.Paragraph>
                The node consumes bandwidth and CPU depending on your application workloads or mining settings,
                which determine how much data traffic flows through the node.
                For mining, high uptime and a stable connection will maximize rewards,
                and at least 8 GB of available RAM is recommended.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={tokens} srcSet={tokens2x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const MineDataTokens = () => (
    <RoundedBox.Gallery items={[Slide1, Slide2, Slide3, Slide4]} />
)

export default MineDataTokens
